import { useState } from 'react';
import { Trans } from '@lingui/macro';
import { Dialog, DialogHeader, DialogContent, DialogFooter, Button, Typography, Avatar, IconButton, } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { KeyDialogMenu, useRegenerateSecret } from 'app/domains/api-management';
import { CloseDialogPrompt } from './components/CloseDialogPrompt';
import { PreviewClient } from '../PreviewClient';
import { PreviewSecret } from '../PreviewSecret';
import { Container, ContentBlock, Divider, HeaderBlock } from './styled';
export function KeyDialog(props) {
    const { apiKey, onClose } = props;
    const [showPrompt, setShowPrompt] = useState(false);
    const [menu, setMenu] = useState(false);
    const { regenerateSecret, loading, data } = useRegenerateSecret();
    const secret = apiKey.clientSecret || (data === null || data === void 0 ? void 0 : data.clientSecret);
    const handleClose = () => {
        if (secret && !showPrompt) {
            setShowPrompt(true);
        }
        else {
            setShowPrompt(false);
            onClose();
        }
    };
    const handleOnClick = () => {
        regenerateSecret(apiKey.id);
    };
    return (<Dialog>
      <DialogHeader title={apiKey.name} media={<Avatar appearance="light" size="xl">
            <Falcon icon="key"/>
          </Avatar>} action={<KeyDialogMenu id={apiKey.id} onClose={() => {
                setMenu(false);
                onClose();
            }} open={menu}>
            <IconButton disabled={!!secret} appearance="ghost" $round onClick={() => setMenu(!menu)}>
              <Falcon icon="ellipsis-vertical"/>
            </IconButton>
          </KeyDialogMenu>}/>
      <DialogContent>
        <Container>
          <ContentBlock>
            <Typography>{apiKey === null || apiKey === void 0 ? void 0 : apiKey.description}</Typography>
            <Typography $appearance="100">
              <Trans comment="Key Dialog - Created by">Created by {apiKey.userName || ''}</Trans>
            </Typography>
          </ContentBlock>

          <Divider />

          <HeaderBlock>
            <Typography $fontSize="large" $fontWeight="medium" $appearance="300">
              <Trans comment="Key Dialog - Client secret & ID title">Client secret & ID</Trans>
            </Typography>
            <Typography>
              <Trans comment="Key Dialog - Client secret & ID description">
                This secret can be used to retrieve and edit your API key later on. Store it
                securely. The secret cannot be retrieved if lost.
              </Trans>
            </Typography>
          </HeaderBlock>

          <ContentBlock>
            <PreviewClient clientId={apiKey.clientId}/>
            <PreviewSecret onClick={handleOnClick} loading={loading} clientSecret={secret}/>
          </ContentBlock>
        </Container>
      </DialogContent>
      <DialogFooter>
        <CloseDialogPrompt open={showPrompt} onClose={() => setShowPrompt(false)} onClick={handleClose}>
          <Button type="button" onClick={handleClose} disabled={showPrompt || loading}>
            <Trans comment="Key Dialog - Close preview dialog">Done</Trans>
          </Button>
        </CloseDialogPrompt>
      </DialogFooter>
    </Dialog>);
}
